import React, { useState } from 'react';
import { Boxed } from '../../components/Boxed.components';
import { Text } from '../../components/Text.components';
import { Plan } from '../../components/Subscription.components';
import { Button } from '../../components/Button.components';

export const Subscription = () => {
  const plans = [
    {
      type: 'Basic Plan',
      price: '100',
      pros: [
        'Ideal for small teams and startups of upto 20 employees',
        'Up to 5 forms available',
        'Basic document approval workflows',
        'Real-time collaboration features',
        'Cloud hosting',
        'Email support',
        'Multi-factor authentication'
      ]
    },
    {
      type: 'Standard Plan',
      price: '200',
      pros: [
        'All features from basic plan',
        'Suitable for growing businesses of upto 50 employees',
        'Up to 10 forms available',
        'Approval workflows and customisation options',
        'Real-time collaboration with comments and annotations',
        'Document tracking and reporting',
        'Enhanced security features',
        'Email and live chat support'
      ]
    },
    {
      type: 'Premium Plan - Custom Pricing',
      price: '300',
      pros: [
        'All features from standard plan',
        'Tailored for large enterprises and organisations with complex approval processes',
        '20+ forms',
        'Advanced customisation and automation capabilities',
        'Advanced reporting and analytics',
        'Premium security features, including user access controls and data encryption',
        'Dedicated account manager',
        '24/7 priority support'
      ]
    }
  ];
  const [showYearly, setShowYearly] = useState(false);
  return (
    <Boxed>
      <Boxed display="flex">
        <Boxed maxWidth="800px" margin="0 auto">
          <Text fontSize="28px" color="#0E1E87" align="center" fontWeight="600">
            We offer flexible pricing plans designed to cater to organisations of all sizes.
          </Text>
          <Text fontSize="16px" align="center">
            Select the plan that best aligns with your requirements and start streamlining your
            approval workflow process today.
          </Text>
        </Boxed>
      </Boxed>
      <Boxed margin="15px auto" textAlign="center">
        <Button onClick={() => setShowYearly(false)} clear={showYearly === false ? false : true}>
          Monthly
        </Button>
        <Button onClick={() => setShowYearly(true)} clear={showYearly === true ? false : true}>
          Yearly
        </Button>
      </Boxed>
      <Boxed display="flex" margin="25px auto" justifyContent="space-between" width="95%">
        {plans.map((plan, index) => (
          <Plan plan={plan} key={index} yearly={showYearly} />
        ))}
      </Boxed>
    </Boxed>
  );
};
